import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-missed-call-icon',
  templateUrl: './communication-missed-call.component.html'
})
export class CommunicationMissedCallComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
